<template>
  <div class="address-info">
    <div class="info-title">
      <img :src="info.infoText.photo">
      <h3>{{info.linkText}}</h3>
    </div>
    <div class="info-con">
      <ul>
        <li class="info-phone">
          <p>overseas business</p>
          <div v-for="(item,index) in info.infoText.overseas" :key="index">
            <span>{{item.phone}}</span>
            <span>{{item.email}}</span>
          </div>
        </li>
        <li class="info-add">
          <p>Address</p>
          <span>{{info.infoText.address}}</span>
        </li>
        <li></li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  props: ["info"]
};
</script>

<style>
/* .overlay {
  width: 330px;
  height: 330px;
  position: relative;
  background: #fff;
  z-index: 999;
} */
.info-title {
  overflow: hidden;
  padding: 0px 10px 0 10px;
  color: #333;
  height: 90px;
}
.info-title img {
  float: left;
  margin-right: 15px;
  height: 100%;
}
.info-title h3 {
  font-size: 22px;
  padding-top: 20px;
  font-weight: normal;
}
.info-con {
}
.info-con p {
  font-size: 16px;
  color: #333;
  padding: 5px 0 5px 20px;
  margin: 10px 0 0 15px;
  text-align: left;
}
.info-con span {
  font-size: 14px;
  color: #777;
  padding-left: 35px;
  display: block;
  text-align: left;
}
.info-phone {
  display: none;
}
.info-phone p {
  background: url(../assets/phone.png) no-repeat left;
}
.info-add p {
  background: url(../assets/address.png) no-repeat left;
}
.info-con a {
  color: #367ad8;
  margin-top: 6px;
  display: inline-block;
  padding-left: 10px;
  font-size: 14px;
  background: url(../assets/go.png) no-repeat left;
  position: absolute;
  bottom: 10px;
  left: 50%;
  transform: translateX(-50%);
}
.amap-info-sharp,
.amap-info-close {
  display: none;
}
.amap-info {
  margin-left: 200px;
  margin-top: 216px;
}
.amap-info-content {
  width: 300px;
  height: 240px;
  overflow: hidden;
}
</style>


// WEBPACK FOOTER //
// src/components/MapInfo.vue